var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraincertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.147,
    height: 26.147,
    viewBox: "0 0 26.147 26.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.896 -9.882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.223,30.676H20V35.7a.327.327,0,0,0,.464.3l2.4-1.107L25.259,36a.327.327,0,0,0,.464-.3V30.676h9.993a.327.327,0,0,0,.327-.327V10.209a.327.327,0,0,0-.327-.327H10.223a.327.327,0,0,0-.327.327v20.14A.327.327,0,0,0,10.223,30.676Zm12.747-2.02a4.206,4.206,0,1,1,4.206-4.206A4.21,4.21,0,0,1,22.969,28.656Zm-2.317.065a4.824,4.824,0,0,0,1.881.567v5.036l-1.881.868Zm2.535,5.6V29.3a4.818,4.818,0,0,0,1.881-.473v6.366ZM10.55,10.536h24.84V30.022H25.723V28.45A4.862,4.862,0,1,0,20,28.287v1.735H10.55Z",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.844,45.464A2.938,2.938,0,1,0,46.782,48.4,2.942,2.942,0,0,0,43.844,45.464Zm0,5.223A2.285,2.285,0,1,1,46.129,48.4,2.287,2.287,0,0,1,43.844,50.687Z",
    transform: "translate(-20.875 -23.952)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,21.241H38.664a.327.327,0,1,0,0-.654H19.1a.327.327,0,1,0,0,.654Z",
    transform: "translate(-5.974 -7.206)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,30.74H38.664a.327.327,0,1,0,0-.654H19.1a.327.327,0,0,0,0,.654Z",
    transform: "translate(-5.974 -13.601)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.672,58.01H19.1a.327.327,0,1,0,0,.654h2.574a.327.327,0,0,0,0-.654Z",
    transform: "translate(-5.974 -32.398)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.672,48.9H19.1a.327.327,0,1,0,0,.654h2.574a.327.327,0,0,0,0-.654Z",
    transform: "translate(-5.974 -26.264)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.663,58.01H71.089a.327.327,0,0,0,0,.654h2.574a.327.327,0,0,0,0-.654Z",
    transform: "translate(-40.973 -32.398)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.663,48.9H71.089a.327.327,0,0,0,0,.654h2.574a.327.327,0,0,0,0-.654Z",
    transform: "translate(-40.973 -26.264)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraincertificate);
export default __webpack_public_path__ + "static/media/traincertificate.ab858367.svg";
export { ForwardRef as ReactComponent };